import React from 'react';

import { usePriceRowContext } from '../../../price-row-context';
import { useAppContext } from 'src/components/app-context';
import { MediumUp, MobileOnly } from 'src/ui/block';

import { IconDropdownDown } from '@prisjakt/ui/icon/dropdown-down';
import { IconDropdownUp } from '@prisjakt/ui/icon/dropdown-up';
import { IconMenuKebab } from '@prisjakt/ui/icon/menu-kebab';

import * as S from './styles';

interface IExpandButton {
  expanded?: boolean;
  onClick?: () => void;
  title?: string;
}

export const ExpandButton: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IExpandButton>
>> = ({ expanded = false, onClick, title }) => {
  const { showExpandButton } = usePriceRowContext();
  const { t } = useAppContext();

  return (
    <S.ExpandButton
      type="button"
      aria-label={title}
      onClick={onClick}
      title={t('product', 'price.expand-row')}
      data-test="ExpandButton"
      $expanded={expanded}
      $hidden={!showExpandButton}
    >
      <MobileOnly>
        <IconMenuKebab color="base900" size={24} />
      </MobileOnly>
      <MediumUp>
        {expanded ? (
          <IconDropdownUp color="base900" size={24} />
        ) : (
          <IconDropdownDown color="base900" size={24} />
        )}
      </MediumUp>
    </S.ExpandButton>
  );
};
